import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { ImportFromExternalSystemComponent } from './import-from-external-system/import-from-external-system.component';

@NgModule({
    declarations: [AdminLayoutComponent, ImportFromExternalSystemComponent],
    imports: [SharedModule],
})
export class AdminModule { }
